import apis from '@/apis/requirement';
import { RequirementStatusEnum } from "@/types/requirement";
import useRequirementParams from "./useRequirementParams";
import { useState } from "react";
import { orderDel } from '@/apis/inventoryv2';
import { ConfirmedEnum } from '@/types/inventory';

export type ChangeRequirementStatus = (id: string, status: RequirementStatusEnum, successCallback: () => void) => Promise<void>;
type UseChangeRequirement = () => [ChangeRequirementStatus, boolean]

const useChangeRequirementStatus: UseChangeRequirement = () => {
  const { params } = useRequirementParams(true);
  const [loading, setLoading] = useState<boolean>(false)

  const onChange: ChangeRequirementStatus = async (id, status, successCallback) => {
    if (id && params && params.confirmType) {
      setLoading(true)
      try {
        let inventories = await apis.inventoryOrders(id);
        if (inventories.body && inventories.body.length > 0) {
          for (let index = 0; index < inventories.body.length; index++) {
            if (inventories.body[index].confirmState !== ConfirmedEnum.CONFIRM)
              await orderDel(inventories.body[index].id)
          }
        }
        await apis.updateByKey(id, { key: 'status', value: status })

        successCallback()
      } catch (e) {

      } finally {
        setLoading(false)
      }
    }
  };

  return [onChange, loading]
};

export default useChangeRequirementStatus;
